import script from "./PriceStrategy.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceStrategy.vue?vue&type=script&setup=true&lang=js"

import "./PriceStrategy.vue?vue&type=style&index=0&id=0f29296c&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f29296c"]])

export default __exports__